import {FiExternalLink} from "react-icons/fi";
import React from "react";

export default function ViewInPlatform({ type, metadata}){
    switch (type) {
        case "facebook-page-post": {
            const permalink_url = metadata?.permalink_url;
            if (permalink_url) {
                return <a href={permalink_url}
                          className={"inline-flex link gap-1 items-center"}
                          target={"_blank"}>View post <FiExternalLink/></a>
            }
        }
            break;
        case "instagram-post":
        case "instagram-reel":{
            const permalink_url = metadata?.permalink_url;
            if (permalink_url) {
                return <a href={permalink_url}
                          className={"inline-flex gap-1 link items-center"}
                          target={"_blank"}>View post <FiExternalLink/></a>
            }
        }
            break;
        case "instagram-story": {
            const links: string[] = [...new Set<string>(Array.isArray(metadata) ? metadata.map((i) => {
                return i.permalink_url
            }) : [])].filter((i)=>!!i);
            if(links.length > 0){
                if(links.length === 1){
                    return <a href={links[0]}
                              className={"inline-flex gap-1 link items-center"}
                              target={"_blank"}>View story <FiExternalLink/></a>
                }else if(links.length > 1){
                    return <span>
                            <span>View Story</span>

                        {
                            links.map((link, index)=>{
                                return <a href={link}
                                          className={"me-2"}
                                          target={"_blank"}>[ {index+1} ]</a>
                            })
                        }
                    </span>
                }
            }
        }

            break;
        case "facebook-page-story":{
            const links: string[] = [...new Set<string>(Array.isArray(metadata) ? metadata.map((i)=>{
                return i.story?.url
            }) : [])].filter((i)=>!!i);
            if(links.length > 0){
                if(links.length === 1){
                    return <a href={links[0]}
                              className={"inline-flex gap-1 items-center"}
                              target={"_blank"}>View story <FiExternalLink/></a>
                }else if(links.length > 1){
                    return <span>
                            <span>View story</span>

                        {
                            links.map((link, index)=>{
                                return <a href={link}
                                          className={"me-2"}
                                          target={"_blank"}>[ {index+1} ]</a>
                            })
                        }
                    </span>
                }
            }
        }



    }


}
